import React, { FC, useCallback, useEffect } from 'react';
import Button, { ButtonProps } from './Button';
import useTranslation from 'hooks/useTranslation';

export interface ConfirmButtonProps extends Omit<ButtonProps, 'variant'> {
  label?: string;
  onClick: () => void;
}

const ConfirmButton: FC<ConfirmButtonProps> = ({ label, ...rest }) => {
  const { t } = useTranslation();

  const keyDownHandler = useCallback(
    (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'Enter' && !rest.disabled) {
        event.preventDefault();
        event.stopPropagation();

        rest.onClick();
      }
    },
    [rest.onClick, rest.disabled],
  );

  useEffect(() => {
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [keyDownHandler]);

  return (
    <Button {...rest} variant="primary">
      {label || t('Confirm')}
    </Button>
  );
};

export default ConfirmButton;
